export default function TeamIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <circle cx="9" cy="8" r="3.25" />
            <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
            <path d="M16 4.6a3.25 3.25 0 0 1 0 6.3" />
            <path d="M18 14.4c1.8.8 3 2.9 3 5.6" />
        </svg>
    );
}
